import { tableDefaults } from "./defaultConfig.js";

export const projectTableConfig = () => ({
    ...tableDefaults,
    columns: [
        { title: "CreatedAt", field: "createdAt", visible: false },
        { title: "Projektname", field: "name", headerFilter: "input" },
        {
            title: "Aktiv",
            field: "isActive",
            width: 100,
            minWidth: 100,
            hozAlign: "center",
            headerFilter: "list",
            headerFilterParams: {
                values: { true: "Aktiv", false: "Inaktiv" },
            },
            formatter: "tickCross",
        },
    ],
});